import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-period-mode-auto-next",
  "use": "icon-period-mode-auto-next-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-period-mode-auto-next\">\n<path d=\"M7.95625 14.47L11.152 9.3568C11.5437 8.73013 12.4563 8.73013 12.848 9.3568L16.0438 14.47C16.46 15.136 15.9812 16 15.1958 16H8.80425C8.01881 16 7.53997 15.136 7.95625 14.47Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol